import React, {Component} from 'react';
import { connect } from 'react-redux';
import {Container} from 'react-bootstrap';
import BlogHeader from '../components/blog/blog-header';
import RelatedBlogs from '../components/related-blogs';

import { fetchAllArticles, fetchLatestArticles } from '../redux/actions/actions';

class Blog extends Component {
  async componentDidMount() {
    const { loadAllArticles, latestArticles, loadLatestArticles } = this.props;
    loadAllArticles();
    if(!latestArticles.length) {
      loadLatestArticles();
    } 
  }
  render() {
    let { allArticles, latestArticles } = this.props;
    return (
      <>
        <BlogHeader articleList={latestArticles}/>
        <Container>
          <RelatedBlogs articleList={allArticles} loadMore={false}/>
        </Container>
      </>
    )
  }
}

const maptStateToProps = ({linenedges}) => ({
  allArticles: linenedges.allArticles,
  latestArticles: linenedges.latestArticles
});

const mapDispatchToProps = dispatch => ({
  loadAllArticles: async () => await dispatch(fetchAllArticles()),
  loadLatestArticles: async() => await dispatch(fetchLatestArticles())
});

export default connect(maptStateToProps, mapDispatchToProps)(Blog);